import React from 'react';
import PropTypes from 'prop-types';

/**
 * Container - A wrapper that renders a standard HTML div with Bulma class names
 * 
 * This component accepts the same props as Bloomer Container for easy migration
 */
const Container = ({
  className = '',
  isFluid = false,
  isWidescreen = false,
  isFullHD = false,
  children = null,
  style = {},
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['container'];
    
    // Add modifier classes
    if (isFluid) {
      classes.push('is-fluid');
    }
    
    if (isWidescreen) {
      classes.push('is-widescreen');
    }
    
    if (isFullHD) {
      classes.push('is-fullhd');
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <div
      className={getClassNames()}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
};

// eslint-disable-next-line react/require-default-props
Container.propTypes = {
  className: PropTypes.string,
  isFluid: PropTypes.bool,
  isWidescreen: PropTypes.bool,
  isFullHD: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node,
};



export default Container;
